export default __webpack_public_path__ + "static/media/services12.5ffdd655.jpg";